export const TEMPLATE_TYPES = {
  HSM: 0, //This template will be not save in our database (whatsapp)
  SURVEY_COMPLETED: 1,
  SURVEY_EXPIRED: 2,
  SURVEY_INVITE: 3,
  SURVEY_REMINDER: 4,
  FINISH_LOOP: 5,
  SURVEY_INVITE_LINKSMS: 6,
  SURVEY_REMINDER_LINKSMS: 7,
  CLOSSING_LOOP: 8
};

export const TEMPLATE_TYPES_LABEL = {
  [TEMPLATE_TYPES.SURVEY_COMPLETED]: "template.types.survey_completed.title",
  [TEMPLATE_TYPES.SURVEY_EXPIRED]: "template.types.survey_expired.title",
  [TEMPLATE_TYPES.SURVEY_INVITE]: "template.types.survey_invite.title",
  [TEMPLATE_TYPES.SURVEY_REMINDER]: "template.types.survey_reminder.title",
  [TEMPLATE_TYPES.FINISH_LOOP]: "template.types.finish_loop.title",
  [TEMPLATE_TYPES.SURVEY_INVITE_LINKSMS]: "template.types.sms_invite.title",
  [TEMPLATE_TYPES.SURVEY_REMINDER_LINKSMS]: "template.types.sms_reminder.title",
  [TEMPLATE_TYPES.FINISH_LOOP]: "template.types.finish_loop.title",
  [TEMPLATE_TYPES.CLOSSING_LOOP]: "template.types.clossing_loop.title"
};

export const TEMPLATE_TYPES_DESCRIPTION = {
  [TEMPLATE_TYPES.SURVEY_COMPLETED]: "template.types.survey_completed.description",
  [TEMPLATE_TYPES.SURVEY_EXPIRED]: "template.types.survey_expired.description",
  [TEMPLATE_TYPES.SURVEY_INVITE]: "template.types.survey_invite.description",
  [TEMPLATE_TYPES.SURVEY_REMINDER]: "template.types.survey_reminder.description",
  [TEMPLATE_TYPES.FINISH_LOOP]: "template.types.finish_loop.description",
  [TEMPLATE_TYPES.SURVEY_INVITE_LINKSMS]: "template.types.sms_invite.description",
  [TEMPLATE_TYPES.SURVEY_REMINDER_LINKSMS]: "template.types.sms_reminder.description",
  [TEMPLATE_TYPES.CLOSSING_LOOP]: "template.types.clossing_loop.description"
};

export const TEMPLATE_ITEM_TYPE = {
  TEXT: 1,
  IMAGE: 2,
  START_SURVEY: 3,
  SENDER: 4,
  DATA_BOOSTER: 5,
  SIGNATURE: 6,
  SMS: 7
};
